import { Box, Paper, Stack, TextField, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { MISC_PRIMARY } from '../../theme/onboardingTheme'

export function StepAttestation() {
  const { state, dispatch } = useOnboarding()

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        bgcolor: '#ffffff',
        p: { xs: 3, sm: 4, lg: 5 },
        boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
      }}
    >
      <Typography
        component="h3"
        sx={{ fontSize: { xs: '1.125rem', sm: '1.25rem' }, fontWeight: 600, color: '#0f172a' }}
      >
        Attestation
      </Typography>

      <Stack spacing={3} sx={{ mt: 3, maxWidth: 768 }}>
        <Typography sx={{ fontSize: { xs: 14, sm: 16 }, lineHeight: 1.625, color: '#1e293b' }}>
          If we identify unfiled transactions that we would like MISC to handle, we understand
          that we need to include them on an open tax report and send them to MISC for processing.
        </Typography>

        <Box>
          <Typography
            component="label"
            htmlFor="attestation-initials"
            sx={{ display: 'block', fontSize: { xs: 14, sm: 16 }, fontWeight: 600, color: '#0f172a' }}
          >
            Your initials*
          </Typography>
          <TextField
            id="attestation-initials"
            type="text"
            autoComplete="off"
            inputProps={{ maxLength: 12 }}
            placeholder="e.g. JM"
            value={state.attestationInitials}
            onChange={(e) =>
              dispatch({ type: 'SET_ATTESTATION_INITIALS', initials: e.target.value })
            }
            size="small"
            sx={{
              mt: 1,
              maxWidth: 320,
              width: '100%',
              '& .MuiOutlinedInput-root': {
                fontSize: 14,
                '& fieldset': { borderColor: '#cbd5e1' },
                '&:hover fieldset': { borderColor: MISC_PRIMARY },
                '&.Mui-focused fieldset': { borderColor: MISC_PRIMARY },
              },
              '& .MuiInputBase-input': {
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                '&::placeholder': {
                  textTransform: 'none',
                  letterSpacing: 'normal',
                },
              },
            }}
          />
          <Typography sx={{ mt: 0.75, fontSize: 12, color: '#64748b' }}>
            Enter your initials to confirm you understand the statement above.
          </Typography>
        </Box>

        <Box
          sx={{
            borderRadius: 1,
            border: '1px solid #bfdbfe',
            bgcolor: '#eff6ff',
            px: 2,
            py: 1.5,
            fontSize: 14,
            lineHeight: 1.625,
            color: '#1e293b',
          }}
        >
          <Typography component="span" sx={{ fontWeight: 600, color: '#0f172a', fontSize: 14 }}>
            Please note:{' '}
          </Typography>
          Depending on the transaction&apos;s effective date and the home state involved, revised
          state reports may be required. Additional fees may apply.
        </Box>
      </Stack>
    </Paper>
  )
}
